import React from 'react'
import { useHistory } from 'react-router'
import cx from 'classnames'
// chakra components
import { Box, Text } from '@chakra-ui/react'

import { updateDocumentTitle } from 'src/utils/helpers'
// styles
import './PageTitle.less'
// components
import FontAwesomeIconComponent from 'src/components/FontAwesomeIcon'

const PageTitle = ({
  title,
  subtitle,
  className,
  showBack,
  showBackMobile,
  rightIcon,
  onRightIconClick,
  goBack,
  ...props
}) => {
  const history = useHistory()

  const handleDocumentTitle = item => {
    const documentTitle = item.title
    updateDocumentTitle(documentTitle)

    return documentTitle
  }

  // useEffect(() => {
  //   try {
  //     // Only if widget and title is not already update with temporary/flashing title
  //     if (this.props.isWidget && Storage.getItem('hasFlashingDocumentTitle') !== '1') {
  //       // Save current document title
  //       storeDocumentTitle()
  //     }
  //   } catch (e) {
  //     console.warn(e)
  //   }

  // }, [])

  const onBack = () => {
    const { setCurrentlyOpenFeature, isWidgetState } = props
    history.listen(nextLocation => {
      if (
        nextLocation &&
        nextLocation.state &&
        nextLocation.state.listItem &&
        setCurrentlyOpenFeature
      ) {
        if (nextLocation.state.listItem.id) {
          setCurrentlyOpenFeature(nextLocation.state.listItem.id)

          if (!isWidgetState) {
            handleDocumentTitle(nextLocation.state.listItem)
          }
        }
      }
      return
    })

    if (showBackMobile) {
      history.push('/')
      return
    }

    if (goBack) {
      goBack()
    } else {
      if (history.length - 1) {
        history.goBack()
      } else {
        history.push('/')
      }
    }
  }

  const layoutPageTitle = cx('layout-page-title', className, {
    'c-layout-page-title': true,
    'kiosk--chakra-colors-background-primary': true,
    'kiosk--chakra-colors-header': true,
  })

  const layoutPageTitleContainer = cx('layout-page-title_container', className, {
    'c-layout-page-title_container': true,
    'with-arrow-back': showBack || subtitle,
    'without-arrow-back': !showBack && !subtitle && showBackMobile && !rightIcon,
    'with-arrow-right': !showBack && !subtitle && showBackMobile && rightIcon,
  })

  const titleContainer = cx({
    'page-title-common': true,
  })

  const layoutPageBackContainer = cx('layout-page-title_back-container', className, {
    'c-layout-page-title_back-container': !showBackMobile,
    'c-layout-page-title_back-mobile': showBackMobile,
  })

  const layoutPageRightIconContainer = cx({
    'c-layout-page-title_right-icon-container': true,
  })

  return (
    <Box className={layoutPageTitle}>
      {/* {!isWidget && setTitle && <Helmet title={handleDocumentTitle()} />} */}
      {showBack || subtitle || showBackMobile ? (
        <button className={layoutPageBackContainer} onClick={onBack}>
          <FontAwesomeIconComponent icon={['fal', 'angle-left']} size='sm' type='header-font' />
        </button>
      ) : null}
      <Box className={layoutPageTitleContainer}>
        <Text className={titleContainer} variant='contrast' fontSize={'20px'} fontWeight={'bold'}>
          {title || ''}
        </Text>
        <Text mt={'4px'} opacity={0.5} variant='contrast' fontSize={'14px'}>
          {subtitle || ''}
        </Text>
      </Box>
      {rightIcon ? (
        <button className={layoutPageRightIconContainer} onClick={() => onRightIconClick()}>
          <FontAwesomeIconComponent icon={['fal', 'arrows-rotate']} size='sm' type='header-font' />
        </button>
      ) : null}
    </Box>
  )
}

export default PageTitle
